module.exports = __webpack_public_path__ + "img/no_image.39d78c94.png";